<template>
  <div class="mx-5">
    <b-row>
      <b-col cols="4" class="pl-0">
        <div class="position-sticky" role="tablist" style="top: 10px; margin-top: 37px;">
          <b-card no-body class="mb-2">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                v-b-toggle.search
                class="normalize align-items-center d-flex justify-content-center"
              >
                <b-icon-search font-scale="0.8"></b-icon-search>
                <span class="ml-2">SEARCH</span>
              </b-button>
            </b-card-header>
            <b-collapse id="search" visible accordion="my-accordion" role="tabpanel">
              <b-card-body class="px-10">
                <b-form @submit.prevent="onSubmit">
                  <!--                <b-form-select-->
                  <!--                  v-model="dateSelected"-->
                  <!--                  :options="datePostedOptions"-->
                  <!--                  class="mb-3 normalize-input "-->
                  <!--                  style="text-align-last: center; font-size: small;"-->
                  <!--                ></b-form-select>-->
                  <b-form-select
                    v-model="categorySelected"
                    :options="categoryOptions"
                    class="mb-3 normalize-input"
                    style="text-align-last: center; font-size: small;"
                  ></b-form-select>
                  <b-form-select
                    required
                    v-model="statusSelected"
                    :options="statusOptions"
                    class="mb-3 normalize-input"
                    style=" text-align-last: center; font-size: small;"
                    :disabled="categorySelected === 'manifest'"
                  ></b-form-select>
                  <b-form-datepicker
                    reset-button
                    v-model="dateSelected"
                    class="mb-3 normalize-input text-center"
                    style="text-align-last: center; font-size: small;"
                  ></b-form-datepicker>
                  <hr class="border-light"/>
                  <div v-if="categorySelected === 'manifest'">
                    <div class="floating-label-alt">
                      <input
                        id="dest"
                        v-model="destination"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="dest"
                        :class="destination !== '' ? 'active': ''"
                      >Destination</label>
                    </div>
                    <div class="floating-label-alt">
                      <!-- <input
                        id="departure"
                        v-model="departure"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      /> -->
                       <b-form-datepicker
                            reset-button
                            v-model="departure"
                            placeholder="Departure Date"
                            class="form-control text-center mb-3 normalize-input"
                      ></b-form-datepicker>
                      <!-- <label
                        for="departure"
                        :class="departure !== '' ? 'active': ''"
                      >Departure Date</label> -->
                    </div>
                    <div class="floating-label-alt">
                      <input
                        id="manifest-number"
                        v-model="manifest"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="manifest-number"
                        :class="manifest !== '' ? 'active': ''"
                      >Manifest #</label>
                    </div>
                    <!-- <div class="floating-label-alt">
                      <input
                        id="completion"
                        v-model="completion"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="completion"
                        :class="completion !== '' ? 'active': ''"
                      >Completion Date</label>
                    </div> -->
                  </div>
                  <div v-else>
                    <div class="floating-label-alt">
                      <input
                        id="bol"
                        v-model="bol"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="bol"
                        :class="bol !== '' ? 'active': ''"
                      >Bill of Lading/Invoice</label>
                    </div>
                    <div class="floating-label-alt">
                      <input
                        id="phone-number"
                        v-model="phoneNumber"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="phone-number"
                        :class="phoneNumber !== '' ? 'active': ''"
                      >Phone Number</label>
                    </div>
                    <div class="floating-label-alt">
                      <input
                        id="name"
                        v-model="name"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="name"
                        :class="name !== '' ? 'active': ''"
                      >Name</label>
                    </div>
                    <div class="floating-label-alt">
                      <input
                        id="destination"
                        v-model="destination"
                        class="form-control text-center mb-3 normalize-input"
                        type="text"
                      />
                      <label
                        for="destination"
                        :class="destination !== '' ? 'active': ''"
                      >Destination</label>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between">
                    <button type="btn" class="btn btn-primary normalize">
<!--                      <b-icon-backspace></b-icon-backspace>-->
                    </button>
                    <button
                      type="btn"
                      class="btn btn-dark d-flex align-items-center"
                      style="border-radius: 25px;"
                    >
                      <b-icon-search font-scale="0.9"></b-icon-search>
                    </button>
                  </div>
                </b-form>
              </b-card-body>
            </b-collapse>
          </b-card>
<!--          <b-card no-body class="mb-1">-->
<!--            <b-card-header header-tag="header" class="p-1" role="tab">-->
<!--              <b-button-->
<!--                block-->
<!--                v-b-toggle.filter-->
<!--                class="normalize align-items-center d-flex justify-content-center"-->
<!--              >-->
<!--                <b-icon-funnel font-scale="0.9"></b-icon-funnel>-->
<!--                <span class="ml-2">FILTER</span>-->
<!--              </b-button>-->
<!--            </b-card-header>-->
<!--            <b-collapse id="filter" accordion="my-accordion" role="tabpanel">-->
<!--              <b-card-body>-->
<!--                <b-form-row v-for="(filter, idx) in filters" :key="idx">-->
<!--                  <b-col>-->
<!--                    <b-form-select-->
<!--                      v-model="filter.columnSelected"-->
<!--                      :options="filterColumnOptions"-->
<!--                      class="mb-3 normalize-input"-->
<!--                      style="text-align-last: center; font-size: small;"-->
<!--                    ></b-form-select>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <b-form-select-->
<!--                      v-model="filter.operationSelected"-->
<!--                      :options="filterOperationOptions"-->
<!--                      class="mb-3 normalize-input"-->
<!--                      style="text-align-last: center; font-size: small;"-->
<!--                    ></b-form-select>-->
<!--                  </b-col>-->
<!--                  <b-col>-->
<!--                    <b-input-->
<!--                      v-model="filter.value"-->
<!--                      placeholder="Value"-->
<!--                      class="mb-3 normalize-input text-center"-->
<!--                      style="text-align-last: center; font-size: small;"-->
<!--                    ></b-input>-->
<!--                  </b-col>-->
<!--                </b-form-row>-->
<!--                <b-button-->
<!--                  variant="dark"-->
<!--                  style="font-size: x-small; border-radius: 25px;"-->
<!--                >-->
<!--                  <b-icon-plus-circle></b-icon-plus-circle>-->
<!--                  <span class="ml-2">Add Filter</span>-->
<!--                </b-button>-->
<!--              </b-card-body>-->
<!--            </b-collapse>-->
<!--          </b-card>-->
        </div>
      </b-col>
      <b-col class="pr-0">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="text-muted" style="font-size: smaller;">
            Showing {{results.length}} results.
          </div>
        </div>
        <div v-if="loading">
          <Loading />
        </div>
        <div
          v-else-if="results.length === 0"
          class="mt-3 text-gray-400 text-2xl"
        >No Results</div>
        <SearchResults
          :items="results"
          v-else
          :name="name"
          :phoneNumber="phoneNumber"
          :destination="destination"
          :bol="bol"
          @change-flag="(idx, value) => {
           changeFlag(idx, value)
          }"
        ></SearchResults>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SearchResults from '../components/SearchResults.vue';
import Loading from '../components/Loading.vue';
import { searchShipment, searchManifest } from '../api/search';
import { updateFlag } from '../api/shipment';

export default {
  name: 'Search',
  components: { Loading, SearchResults },
  data() {
    return {
      currentUser: JSON.parse(localStorage.getItem('user')),
      loading: false,
      infiniteScroll: true,
      page: 1,
      departure: '',
      manifest: '',
      completion: '',
      accountNumber: '',
      bol: '',
      phoneNumber: '',
      name: '',
      destination: '',
      dateSelected: null,
      categorySelected: 'shipment',
      categoryOptions: [
        { value: null, text: 'Category', disabled: true },
        { value: 'shipment', text: 'Shipment Orders' },
        { value: 'manifest', text: 'Manifest Details' },
      ],
      statusSelected: null,
      statusOptions: [
        { value: null, text: 'Status', disabled: true },
        { value: 'pickup', text: 'Pickup Requests' },
        { value: 'toload', text: 'Warehouse Record' },
        { value: 'tooffload', text: 'Offload Record' },
        { value: 'todeliver', text: 'Delivering Shipments' },
        { value: 'completed', text: 'Completed Shipments' },
      ],
      filterColumnOptions: [
        { value: null, text: 'Column Name' },
        { value: 'account', text: 'Account' },
        { value: 'phone', text: 'Phone' },
        { value: 'sender', text: 'Sender' },
        { value: 'consignee', text: 'Consignee' },
        { value: 'origin', text: 'Origin' },
        { value: 'destination', text: 'Destination' },
        { value: 'bol', text: 'Bill of Lading' },
      ],
      filterOperationOptions: [
        { value: null, text: 'Operation' },
        { value: 'equals to', text: 'Equals to' },
        { value: 'contains', text: 'Contains' },
      ],
      filters: [
        {
          columnSelected: null,
          operationSelected: null,
          value: '',
        },
      ],
      results: [],
    };
  },
  computed: {
    // fuse() {
    //   return new Fuse(this.items, {
    //     keys: ['id', 'account', 'phone', 'sender', 'exporter', 'dateCreated', 'datePosted',
    //        'consignee', 'origin', 'destination', 'bol'],
    //     useExtendedSearch: true,
    //   });
    // },
    // results() {
    //   return this.items;
    //   // // FIXME: Debounce this.
    //   // let values = [
    //   //   this.bol,
    //   //   this.phoneNumber,
    //   //   this.name,
    //   //   this.destination,
    //   // ];
    //   // values = values.filter((v) => v);
    //   // values = values.map((v) => `'${v}`);
    //   // return this.fuse.search(values.join(' ')).map((res) => res.item);
    // },
    // searching() {
    //   return !!(this.bol || this.phoneNumber || this.name || this.destination);
    // },
  },
  methods: {
    changeFlag(idx, value) {
      const data = {
        data: {
          type: this.categorySelected,
          flag: value,
          id: this.results[idx].id,
          bookingId: this.results[idx].booking,
        },
      };
      updateFlag(data).then((res) => {
        console.log(res);
        this.results[idx].flag = value;
      }).catch((err) => {
        console.log(err);
      });
    },
    onSubmit() {
      this.$router.replace(
        {
          query: {
            ...Object.fromEntries(Object.entries({
              accountNumber: this.accountNumber,
              bol: this.bol,
              phoneNumber: this.phoneNumber,
              name: this.name.toLowerCase().trim(),
              destination: this.destination.toLowerCase().trim(),
              status: this.statusSelected,
              date: this.dateSelected,
            }).filter((kv) => !!kv[1])),
          },
        },
      ).catch();
      this.loading = true;

      if (this.categorySelected === 'manifest') {
        searchManifest(
          this.dateSelected, this.currentUser.timezone, this.manifest,
          this.departure, this.destination,
        ).then((res) => {
          console.log(res);
          this.results = res.data.results;
          this.loading = false;
        }).catch((err) => {
          console.log(err);
          this.results = [];
          this.loading = false;
        });
      } else {
        searchShipment(
          this.statusSelected, this.dateSelected, this.currentUser.timezone,
          this.bol, this.phoneNumber, this.name, this.destination,
        ).then((res) => {
          console.log(res);
          this.results = res.data.results;
          this.loading = false;
        }).catch((err) => {
          console.log(err);
          this.results = [];
          this.loading = false;
        });
      }
    },
    // loadMore() {
    //   // Testing more data
    //   for (let num = 0; num < 20; num += 1) {
    //     this.results.push({
    //       id: nanoid(),
    //       bookingId: null,
    //       consigneeAddress: '1 Infinite Loop',
    //       consigneeCity: 'Cupertino',
    //       consigneeCountry: 'United States',
    //       consigneeName: 'Dennis Albreight',
    //       consigneePhone: '1(415)555-5555',
    //       dateCreated: 'Wed, 21 Apr 2021 00:00:00 GMT',
    //       flag: 'delayed',
    //       items: [{ description: 'C', id: 26, pickedUp: 'false' }, {
    //         description: 'Dried Goods',
    //         id: 25,
    //         pickedUp: 'false',
    //       }, {
    //         description: 'Household Goods',
    //         id: 34,
    //         pickedUp: 'false',
    //       }, { description: 'Dried Goods', id: 35, pickedUp: 'false' }, {
    //         description: 'C',
    //         id: 27,
    //         pickedUp: 'false',
    //       }, { description: 'A', id: 28, pickedUp: 'false' }, {
    //         description: 'B',
    //         id: 29,
    //         pickedUp: 'false',
    //       }, { description: 'C', id: 30, pickedUp: 'false' }],
    //       outStandingBalance: 100,
    //       pickupDate: 'Wed, 21 Apr 2021 00:00:00 GMT',
    //       resultType: 'PICKUP',
    //       shipmentId: 'xENFjvQNKUsQhw8eEzcxn',
    //       shipperAccount: 398,
    //       shipperCity: 'Quahog',
    //       shipperCountry: 'United States',
    //       shipperName: "Candace O'Leary",
    //       shipperPhone: '1(415)555-5555',
    //     });
    //   }
    // },
    // loadAtEnd(load) {
    //   const bottomOfWindow = document.documentElement.offsetHeight
    //     - (document.documentElement.scrollTop + window.innerHeight);
    //   const offset = 100;
    //   if (bottomOfWindow < offset) {
    //     load();
    //     return true;
    //   }
    //   return false;
    // },
  },
  mounted() {
    // const load = debounce(this.loadMore, 200);
    // window.onscroll = () => {
    //   if (!this.result || this.result.length === 0) {
    //     this.loadAtEnd(load);
    //   }
    // };
    // let end = false;
    // while (!end) {
    //   end = this.loadAtEnd(load);
    // }

    this.accountNumber = this.$route.query.accountNumber === undefined ? '' : this.$route.query.accountNumber;
    this.bol = this.$route.query.bol === undefined ? '' : this.$route.query.bol;
    this.phoneNumber = this.$route.query.phoneNumber === undefined ? '' : this.$route.query.phoneNumber;
    this.name = this.$route.query.name === undefined ? '' : this.$route.query.name;
    this.destination = this.$route.query.destination === undefined ? '' : this.$route.query.destination;
    this.statusSelected = this.$route.query.status === undefined ? null : this.$route.query.status;
    this.dateSelected = this.$route.query.date === undefined ? null : this.$route.query.date;

    if (this.accountNumber || this.bol || this.phoneNumber || this.name || this.destination
      || this.status || this.dateSelected) {
      this.onSubmit();
    }
  },
};
</script>

<style scoped>
::v-deep .normalize {
  outline: none;
  box-shadow: none;
  background-color: transparent;
  border: none;
  padding-left: 0;
  padding-right: 0;
}

::v-deep.normalize:focus, .normalize:active {
  outline: none;
  box-shadow: none !important;
  background-color: transparent !important;
  border: none;
}

.normalize-input {
  outline: none;
  box-shadow: none;
  border: none;
  padding-left: 0;
  padding-right: 0;
}

.normalize-input:focus, .normalize-input:active {
  outline: none;
  box-shadow: none !important;
  /*border: 2px solid var(--complementary-color);*/
}

.card, .card-header {
  border: none;
}

.card-header {
  background: transparent;
}

.card {
  background: var(--secondary-color);
  border-radius: 10px !important;
  color: white;
  box-shadow: 0 0 5px 0 rgba(0,0,0,.2);
}

.card-body {
  padding-top: 5px;
}

::v-deep table.results {
  background: white;
  box-shadow: 0 2px 5px 0 rgba(0,0,0,.2);
  border-radius: 8px;
  overflow: hidden;
}

::v-deep table.results th {
  border-top: none;
  padding: 1.25rem 0.75rem;
}

::v-deep table.results tr.table-active {
  border: none;
  outline: none;
  border-radius: 10px;
}

::v-deep table.results td {
  padding: 1.25rem 0.75rem;
}

.rounded {
  border-radius: 25px;
}

::v-deep .drop-menu {
  border: none;
  font-size: smaller;
  margin-top: 5px;
  color: white;
  background: var(--secondary-color);
  box-shadow: 0 0 4px 0 rgba(0,0,0,0.2);
}

::v-deep .drop-menu li a:hover {
  background: var(--hover-color);
}

.floating-label-alt {
  position: relative;
}

.floating-label-alt label {
  /*font-size: smaller;*/
  pointer-events: none;
  position: absolute;
  transform: translateX(-50%);
  top: 10px;
  z-index: 1;
  color: gray;
  transition: all 0.15s ease-out;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.floating-label-alt input:focus + label, .floating-label-alt label.active {
  font-size: x-small;
  top: 5px;
}

.floating-label-alt input {
  padding-top: 30px;
  padding-bottom: 15px;
  font-size: smaller;
}

.floating-label-alt input {
  padding-top: 30px;
  padding-bottom: 15px;
  font-size: smaller;
}
</style>
